/**
 * How a single polygon is named wherever the map, the context menu, or a validation message
 * has to point at one: `M2.P3` for the third polygon of the second feature, and plain `P2`
 * when the feature holds only one polygon and the M-number would be noise.
 *
 * One copy, because these labels are how a person finds the polygon being talked about — a
 * message that numbers them differently from the map sends them hunting for something that
 * isn't there.
 */
export function polygonPartLabel(featureIndex: number, pathIndex: number, isMulti: boolean): string {
	return isMulti ? `M${featureIndex + 1}.P${pathIndex + 1}` : `P${featureIndex + 1}`;
}
